// Tax Declaration
export const TAX_DECLARATION_GET_REQUEST = "TAX_DECLARATION_GET_REQUEST";
export const TAX_DECLARATION_GET_SUCCESS = "TAX_DECLARATION_GET_SUCCESS";
export const TAX_DECLARATION_GET_ERROR = "TAX_DECLARATION_GET_ERROR";

export const TAX_DECLARATION_ADD_REQUEST = "TAX_DECLARATION_ADD_REQUEST";
export const TAX_DECLARATION_ADD_SUCCESS = "TAX_DECLARATION_ADD_SUCCESS";
export const TAX_DECLARATION_ADD_ERROR = "TAX_DECLARATION_ADD_ERROR";

export const TAX_DECLARATION_UPDATE_REQUEST = "TAX_DECLARATION_UPDATE_REQUEST";
export const TAX_DECLARATION_UPDATE_SUCCESS = "TAX_DECLARATION_UPDATE_SUCCESS";
export const TAX_DECLARATION_UPDATE_ERROR = "TAX_DECLARATION_UPDATE_ERROR";

export const TAX_DECLARATION_EXECUTIVE_GET_REQUEST ="TAX_DECLARATION_EXECUTIVE_GET_REQUEST"
export const TAX_DECLARATION_EXECUTIVE_GET_SUCCESS = "TAX_DECLARATION_EXECUTIVE_GET_SUCCESS"
export const TAX_DECLARATION_EXECUTIVE_GET_ERROR = "TAX_DECLARATION_EXECUTIVE_GET_ERROR"

export const TAX_DECLARATION_EXECUTIVE_UPDATE_REQUEST = "TAX_DECLARATION_EXECUTIVE_UPDATE_REQUEST"
export const TAX_DECLARATION_EXECUTIVE_UPDATE_SUCCESS = "TAX_DECLARATION_EXECUTIVE_UPDATE_SUCCESS"
export const TAX_DECLARATION_EXECUTIVE_UPDATE_ERROR = "TAX_DECLARATION_EXECUTIVE_UPDATE_ERROR"

export const TAX_EMPLOYEE_TOGGLE_INFO_GET_REQUEST = "TAX_EMPLOYEE_TOGGLE_INFO_GET_REQUEST"
export const TAX_EMPLOYEE_TOGGLE_INFO_GET_SUCCESS = "TAX_EMPLOYEE_TOGGLE_INFO_GET_SUCCESS"
export const TAX_EMPLOYEE_TOGGLE_INFO_GET_ERROR = "TAX_EMPLOYEE_TOGGLE_INFO_GET_ERROR"

export const TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_REQUEST = "TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_REQUEST"
export const TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_SUCCESS = "TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_SUCCESS"
export const TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_ERROR = "TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_ERROR"

// Employee Profile
export const EMPLOYEE_PROFILE_PAYROLL_GET_REQUEST = "EMPLOYEE_PROFILE_PAYROLL_GET_REQUEST";
export const EMPLOYEE_PROFILE_PAYROLL_GET_SUCCESS = "EMPLOYEE_PROFILE_PAYROLL_GET_SUCCESS";
export const EMPLOYEE_PROFILE_PAYROLL_GET_ERROR = "EMPLOYEE_PROFILE_PAYROLL_GET_ERROR";

// Salary Structure
export const SALARY_STRUCTURE_GET_REQUEST = "SALARY_STRUCTURE_GET_REQUEST";
export const SALARY_STRUCTURE_GET_SUCCESS = "SALARY_STRUCTURE_GET_SUCCESS";
export const SALARY_STRUCTURE_GET_ERROR = "SALARY_STRUCTURE_GET_ERROR";

export const SALARY_STRUCTURE_ADD_REQUEST = "SALARY_STRUCTURE_ADD_REQUEST";
export const SALARY_STRUCTURE_ADD_SUCCESS = "SALARY_STRUCTURE_ADD_SUCCESS";
export const SALARY_STRUCTURE_ADD_ERROR = "SALARY_STRUCTURE_ADD_ERROR";

export const SALARY_STRUCTURE_UPDATE_REQUEST = "SALARY_STRUCTURE_UPDATE_REQUEST";
export const SALARY_STRUCTURE_UPDATE_SUCCESS = "SALARY_STRUCTURE_UPDATE_SUCCESS";
export const SALARY_STRUCTURE_UPDATE_ERROR = "SALARY_STRUCTURE_UPDATE_ERROR";

export const SALARY_STRUCTURE_DELETE_REQUEST = "SALARY_STRUCTURE_DELETE_REQUEST";
export const SALARY_STRUCTURE_DELETE_SUCCESS = "SALARY_STRUCTURE_DELETE_SUCCESS";
export const SALARY_STRUCTURE_DELETE_ERROR = "SALARY_STRUCTURE_DELETE_ERROR";

//Salary Components
export const SALARY_COMPONENT_GET_REQUEST = "SALARY_COMPONENT_GET_REQUEST";
export const SALARY_COMPONENT_GET_SUCCESS = "SALARY_COMPONENT_GET_SUCCESS";
export const SALARY_COMPONENT_GET_ERROR = "SALARY_COMPONENT_GET_ERROR";

export const SALARY_COMPONENT_ADD_REQUEST = "SALARY_COMPONENT_ADD_REQUEST";
export const SALARY_COMPONENT_ADD_SUCCESS = "SALARY_COMPONENT_ADD_SUCCESS";
export const SALARY_COMPONENT_ADD_ERROR = "SALARY_COMPONENT_ADD_ERROR";

export const SALARY_COMPONENT_UPDATE_REQUEST = "SALARY_COMPONENT_UPDATE_REQUEST";
export const SALARY_COMPONENT_UPDATE_SUCCESS = "SALARY_COMPONENT_UPDATE_SUCCESS";
export const SALARY_COMPONENT_UPDATE_ERROR = "SALARY_COMPONENT_UPDATE_ERROR";

export const SALARY_COMPONENT_DELETE_REQUEST = "SALARY_COMPONENT_DELETE_REQUEST";
export const SALARY_COMPONENT_DELETE_SUCCESS = "SALARY_COMPONENT_DELETE_SUCCESS";
export const SALARY_COMPONENT_DELETE_ERROR = "SALARY_COMPONENT_DELETE_ERROR";

// Salary Component Types
export const SALARY_COMPONENT_TYPE_GET_REQUEST = "SALARY_COMPONENT_TYPE_GET_REQUEST";
export const SALARY_COMPONENT_TYPE_GET_SUCCESS = "SALARY_COMPONENT_TYPE_GET_SUCCESS";
export const SALARY_COMPONENT_TYPE_GET_ERROR = "SALARY_COMPONENT_TYPE_GET_ERROR";


//Components

export const PAYROLL_EARNING_GET_REQUEST = "PAYROLL_EARNING_GET_REQUEST";
export const PAYROLL_EARNING_GET_SUCCESS = "PAYROLL_EARNING_GET_SUCCESS";
export const PAYROLL_EARNING_GET_ERROR = "PAYROLL_EARNING_GET_ERROR";

export const PAYROLL_DEDUCTION_GET_REQUEST = "PAYROLL_DEDUCTION_GET_REQUEST";
export const PAYROLL_DEDUCTION_GET_SUCCESS = "PAYROLL_DEDUCTION_GET_SUCCESS";
export const PAYROLL_DEDUCTION_GET_ERROR = "PAYROLL_DEDUCTION_GET_ERROR";

export const PAYROLL_CUSTOM_EARNING_GET_REQUEST = "PAYROLL_CUSTOM_EARNING_GET_REQUEST";
export const PAYROLL_CUSTOM_EARNING_GET_SUCCESS = "PAYROLL_CUSTOM_EARNING_GET_SUCCESS";
export const PAYROLL_CUSTOM_EARNING_GET_ERROR = "PAYROLL_CUSTOM_EARNING_GET_ERROR";

export const PAYROLL_CUSTOM_DEDUCTION_GET_REQUEST = "PAYROLL_CUSTOM_DEDUCTION_GET_REQUEST";
export const PAYROLL_CUSTOM_DEDUCTION_GET_SUCCESS = "PAYROLL_CUSTOM_DEDUCTION_GET_SUCCESS";
export const PAYROLL_CUSTOM_DEDUCTION_GET_ERROR = "PAYROLL_CUSTOM_DEDUCTION_GET_ERROR";

// Payroll Template

export const PAYROLL_TEMPLATE_GET_REQUEST = "PAYROLL_TEMPLATE_GET_REQUEST";
export const PAYROLL_TEMPLATE_GET_SUCCESS = "PAYROLL_TEMPLATE_GET_SUCCESS";
export const PAYROLL_TEMPLATE_GET_ERROR = "PAYROLL_TEMPLATE_GET_ERROR";

export const PAYROLL_TEMPLATE_ADD_REQUEST = "PAYROLL_TEMPLATE_ADD_REQUEST";
export const PAYROLL_TEMPLATE_ADD_SUCCESS = "PAYROLL_TEMPLATE_ADD_SUCCESS";
export const PAYROLL_TEMPLATE_ADD_ERROR = "PAYROLL_TEMPLATE_ADD_ERROR";

export const PAYROLL_TEMPLATE_UPDATE_REQUEST = "PAYROLL_TEMPLATE_UPDATE_REQUEST";
export const PAYROLL_TEMPLATE_UPDATE_SUCCESS = "PAYROLL_TEMPLATE_UPDATE_SUCCESS";
export const PAYROLL_TEMPLATE_UPDATE_ERROR = "PAYROLL_TEMPLATE_UPDATE_ERROR";

export const PAYROLL_TEMPLATE_DELETE_REQUEST = "PAYROLL_TEMPLATE_DELETE_REQUEST";
export const PAYROLL_TEMPLATE_DELETE_SUCCESS = "PAYROLL_TEMPLATE_DELETE_SUCCESS";
export const PAYROLL_TEMPLATE_DELETE_ERROR = "PAYROLL_TEMPLATE_DELETE_ERROR";

// Employee Template

export const EMPLOYEE_TEMPLATE_GET_REQUEST = "EMPLOYEE_TEMPLATE_GET_REQUEST";
export const EMPLOYEE_TEMPLATE_GET_SUCCESS = "EMPLOYEE_TEMPLATE_GET_SUCCESS";
export const EMPLOYEE_TEMPLATE_GET_ERROR = "EMPLOYEE_TEMPLATE_GET_ERROR";

export const EMPLOYEE_TEMPLATE_ADD_REQUEST = "EMPLOYEE_TEMPLATE_ADD_REQUEST";
export const EMPLOYEE_TEMPLATE_ADD_SUCCESS = "EMPLOYEE_TEMPLATE_ADD_SUCCESS";
export const EMPLOYEE_TEMPLATE_ADD_ERROR = "EMPLOYEE_TEMPLATE_ADD_ERROR";

export const EMPLOYEE_TEMPLATE_UPDATE_REQUEST = "EMPLOYEE_TEMPLATE_UPDATE_REQUEST";
export const EMPLOYEE_TEMPLATE_UPDATE_SUCCESS = "EMPLOYEE_TEMPLATE_UPDATE_SUCCESS";
export const EMPLOYEE_TEMPLATE_UPDATE_ERROR = "EMPLOYEE_TEMPLATE_UPDATE_ERROR";

export const WAGE_REPORT_GET_REQUEST = "WAGE_REPORT_GET_REQUEST";
export const WAGE_REPORT_GET_SUCCESS = "WAGE_REPORT_GET_SUCCESS";
export const WAGE_REPORT_GET_ERROR = "WAGE_REPORT_GET_ERROR";

export const WAGE_REPORT_NOT_PROCESSED_GET_REQUEST = "WAGE_REPORT_NOT_PROCESSED_GET_REQUEST";
export const WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS = "WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS";
export const WAGE_REPORT_NOT_PROCESSED_GET_ERROR = "WAGE_REPORT_NOT_PROCESSED_GET_ERROR";

export const CONTRACTUAL_WAGE_REPORT_GET_REQUEST = "CONTRACTUAL_WAGE_REPORT_GET_REQUEST";
export const CONTRACTUAL_WAGE_REPORT_GET_SUCCESS = "CONTRACTUAL_WAGE_REPORT_GET_SUCCESS";
export const CONTRACTUAL_WAGE_REPORT_GET_ERROR = "CONTRACTUAL_WAGE_REPORT_GET_ERROR";

export const CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST = "CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST";
export const CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS = "CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS";
export const CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_ERROR = "CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_ERROR";

export const DAILY_WAGE_REPORT_GET_REQUEST = "DAILY_WAGE_REPORT_GET_REQUEST";
export const DAILY_WAGE_REPORT_GET_SUCCESS = "DAILY_WAGE_REPORT_GET_SUCCESS";
export const DAILY_WAGE_REPORT_GET_ERROR = "DAILY_WAGE_REPORT_GET_ERROR";

export const DAILY_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST = "DAILY_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST";
export const DAILY_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS = "DAILY_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS";
export const DAILY_WAGE_REPORT_NOT_PROCESSED_GET_ERROR = "DAILY_WAGE_REPORT_NOT_PROCESSED_GET_ERROR";

export const EMPLOYEE_TIME_GET_REQUEST = "EMPLOYEE_TIME_GET_REQUEST";
export const EMPLOYEE_TIME_GET_SUCCESS = "EMPLOYEE_TIME_GET_SUCCESS";
export const EMPLOYEE_TIME_GET_ERROR = "EMPLOYEE_TIME_GET_ERROR";

export const EMPLOYEE_FACE_TIME_GET_REQUEST = "EMPLOYEE_FACE_TIME_GET_REQUEST";
export const EMPLOYEE_FACE_TIME_GET_SUCCESS = "EMPLOYEE_FACE_TIME_GET_SUCCESS";
export const EMPLOYEE_FACE_TIME_GET_ERROR = "EMPLOYEE_FACE_TIME_GET_ERROR";

export const PAYROLL_SETTINGS_COMPONENT_GET_REQUEST = "PAYROLL_SETTINGS_COMPONENT_GET_REQUEST";
export const PAYROLL_SETTINGS_COMPONENT_GET_SUCCESS = "PAYROLL_SETTINGS_COMPONENT_GET_SUCCESS";
export const PAYROLL_SETTINGS_COMPONENT_GET_ERROR = "PAYROLL_SETTINGS_COMPONENT_GET_ERROR";

export const LWF_ADD_REQUEST = "LWF_ADD_REQUEST";
export const LWF_ADD_SUCCESS = "LWF_ADD_SUCCESS";
export const LWF_ADD_ERROR = "LWF_ADD_ERROR";

export const LWF_UPDATE_REQUEST = "LWF_UPDATE_REQUEST";
export const LWF_UPDATE_SUCCESS = "LWF_UPDATE_SUCCESS";
export const LWF_UPDATE_ERROR = "LWF_UPDATE_ERROR";

export const LWF_DELETE_REQUEST = "LWF_DELETE_REQUEST";
export const LWF_DELETE_SUCCESS = "LWF_DELETE_SUCCESS";
export const LWF_DELETE_ERROR = "LWF_DELETE_ERROR";

export const OT_GET_REQUEST = "OT_GET_REQUEST";
export const OT_GET_SUCCESS = "OT_GET_SUCCESS";
export const OT_GET_ERROR = "OT_GET_ERROR";

export const OT_ADD_REQUEST = "OT_ADD_REQUEST";
export const OT_ADD_SUCCESS = "OT_ADD_SUCCESS";
export const OT_ADD_ERROR = "OT_ADD_ERROR";

export const OT_UPDATE_REQUEST = "OT_UPDATE_REQUEST";
export const OT_UPDATE_SUCCESS = "OT_UPDATE_SUCCESS";
export const OT_UPDATE_ERROR = "OT_UPDATE_ERROR";

export const OT_DELETE_REQUEST = "OT_DELETE_REQUEST";
export const OT_DELETE_SUCCESS = "OT_DELETE_SUCCESS";
export const OT_DELETE_ERROR = "OT_DELETE_ERROR";

export const CALCULATE_EMPLOYEE_TEMPLATE_REQUEST = "CALCULATE_EMPLOYEE_TEMPLATE_REQUEST";
export const CALCULATE_EMPLOYEE_TEMPLATE_SUCCESS = "CALCULATE_EMPLOYEE_TEMPLATE_SUCCESS";
export const CALCULATE_EMPLOYEE_TEMPLATE_ERROR = "CALCULATE_EMPLOYEE_TEMPLATE_ERROR";

export const CALCULATE_EMPLOYEE_TEMPLATE_ADD_REQUEST = "CALCULATE_EMPLOYEE_TEMPLATE_ADD_REQUEST";
export const CALCULATE_EMPLOYEE_TEMPLATE_ADD_SUCCESS = "CALCULATE_EMPLOYEE_TEMPLATE_ADD_SUCCESS";
export const CALCULATE_EMPLOYEE_TEMPLATE_ADD_ERROR = "CALCULATE_EMPLOYEE_TEMPLATE_ADD_ERROR";

export const CALCULATE_EMPLOYEE_TEMPLATE_GET_REQUEST = "CALCULATE_EMPLOYEE_TEMPLATE_GET_REQUEST";
export const CALCULATE_EMPLOYEE_TEMPLATE_GET_SUCCESS = "CALCULATE_EMPLOYEE_TEMPLATE_GET_SUCCESS";
export const CALCULATE_EMPLOYEE_TEMPLATE_GET_ERROR = "CALCULATE_EMPLOYEE_TEMPLATE_GET_ERROR";

export const PAY_DATE_GET_REQUEST = "PAY_DATE_GET_REQUEST";
export const PAY_DATE_GET_SUCCESS = "PAY_DATE_GET_SUCCESS";
export const PAY_DATE_GET_ERROR = "PAY_DATE_GET_ERROR";

export const PAY_DATE_UPDATE_REQUEST = "PAY_DATE_UPDATE_REQUEST";
export const PAY_DATE_UPDATE_SUCCESS = "PAY_DATE_UPDATE_SUCCESS";
export const PAY_DATE_UPDATE_ERROR = "PAY_DATE_UPDATE_ERROR";

export const PAYROLL_APPROVER_GET_REQUEST = "PAYROLL_APPROVER_GET_REQUEST";
export const PAYROLL_APPROVER_GET_SUCCESS = "PAYROLL_APPROVER_GET_SUCCESS";
export const PAYROLL_APPROVER_GET_ERROR = "PAYROLL_APPROVER_GET_ERROR";

export const PAYROLL_APPROVER_UPDATE_REQUEST = "PAYROLL_APPROVER_UPDATE_REQUEST";
export const PAYROLL_APPROVER_UPDATE_SUCCESS = "PAYROLL_APPROVER_UPDATE_SUCCESS";
export const PAYROLL_APPROVER_UPDATE_ERROR = "PAYROLL_APPROVER_UPDATE_ERROR";

export const PAYROLL_TILE_VIEW_GET_REQUEST = "PAYROLL_TILE_VIEW_GET_REQUEST";
export const PAYROLL_TILE_VIEW_GET_SUCCESS = "PAYROLL_TILE_VIEW_GET_SUCCESS";
export const PAYROLL_TILE_VIEW_GET_ERROR = "PAYROLL_TILE_VIEW_GET_ERROR";

export const LEAVE_WAGE_GET_REQUEST = "LEAVE_WAGE_GET_REQUEST";
export const LEAVE_WAGE_GET_SUCCESS = "LEAVE_WAGE_GET_SUCCESS";
export const LEAVE_WAGE_GET_ERROR = "LEAVE_WAGE_GET_ERROR";

export const LEAVE_WAGE_ADD_REQUEST = "LEAVE_WAGE_ADD_REQUEST";
export const LEAVE_WAGE_ADD_SUCCESS = "LEAVE_WAGE_ADD_SUCCESS";
export const LEAVE_WAGE_ADD_ERROR = "LEAVE_WAGE_ADD_ERROR";

export const LEAVE_WAGE_UPDATE_REQUEST = "LEAVE_WAGE_UPDATE_REQUEST";
export const LEAVE_WAGE_UPDATE_SUCCESS = "LEAVE_WAGE_UPDATE_SUCCESS";
export const LEAVE_WAGE_UPDATE_ERROR = "LEAVE_WAGE_UPDATE_ERROR";

export const LEAVE_WAGE_DELETE_REQUEST = "LEAVE_WAGE_DELETE_REQUEST";
export const LEAVE_WAGE_DELETE_SUCCESS = "LEAVE_WAGE_DELETE_SUCCESS";
export const LEAVE_WAGE_DELETE_ERROR = "LEAVE_WAGE_DELETE_ERROR";

export const FOOD_ALLOWANCE_GET_REQUEST = "FOOD_ALLOWANCE_GET_REQUEST";
export const FOOD_ALLOWANCE_GET_SUCCESS = "FOOD_ALLOWANCE_GET_SUCCESS";
export const FOOD_ALLOWANCE_GET_ERROR = "FOOD_ALLOWANCE_GET_ERROR";

export const FOOD_ALLOWANCE_UPDATE_REQUEST = "FOOD_ALLOWANCE_UPDATE_REQUEST";
export const FOOD_ALLOWANCE_UPDATE_SUCCESS = "FOOD_ALLOWANCE_UPDATE_SUCCESS";
export const FOOD_ALLOWANCE_UPDATE_ERROR = "FOOD_ALLOWANCE_UPDATE_ERROR";

export const TRANSPORT_ALLOWANCE_GET_REQUEST = "TRANSPORT_ALLOWANCE_GET_REQUEST";
export const TRANSPORT_ALLOWANCE_GET_SUCCESS = "TRANSPORT_ALLOWANCE_GET_SUCCESS";
export const TRANSPORT_ALLOWANCE_GET_ERROR = "TRANSPORT_ALLOWANCE_GET_ERROR";

export const TRANSPORT_ALLOWANCE_ADD_REQUEST = "TRANSPORT_ALLOWANCE_ADD_REQUEST";
export const TRANSPORT_ALLOWANCE_ADD_SUCCESS = "TRANSPORT_ALLOWANCE_ADD_SUCCESS";
export const TRANSPORT_ALLOWANCE_ADD_ERROR = "TRANSPORT_ALLOWANCE_ADD_ERROR";

export const TRANSPORT_ALLOWANCE_UPDATE_REQUEST = "TRANSPORT_ALLOWANCE_UPDATE_REQUEST";
export const TRANSPORT_ALLOWANCE_UPDATE_SUCCESS = "TRANSPORT_ALLOWANCE_UPDATE_SUCCESS";
export const TRANSPORT_ALLOWANCE_UPDATE_ERROR = "TRANSPORT_ALLOWANCE_UPDATE_ERROR";

export const TRANSPORT_ALLOWANCE_DELETE_REQUEST = "TRANSPORT_ALLOWANCE_DELETE_REQUEST";
export const TRANSPORT_ALLOWANCE_DELETE_SUCCESS = "TRANSPORT_ALLOWANCE_DELETE_SUCCESS";
export const TRANSPORT_ALLOWANCE_DELETE_ERROR = "TRANSPORT_ALLOWANCE_DELETE_ERROR";

export const PH_ALLOWANCE_GET_REQUEST = "PH_ALLOWANCE_GET_REQUEST";
export const PH_ALLOWANCE_GET_SUCCESS = "PH_ALLOWANCE_GET_SUCCESS";
export const PH_ALLOWANCE_GET_ERROR = "PH_ALLOWANCE_GET_ERROR";

export const PH_ALLOWANCE_ADD_REQUEST = "PH_ALLOWANCE_ADD_REQUEST";
export const PH_ALLOWANCE_ADD_SUCCESS = "PH_ALLOWANCE_ADD_SUCCESS";
export const PH_ALLOWANCE_ADD_ERROR = "PH_ALLOWANCE_ADD_ERROR";

export const PH_ALLOWANCE_UPDATE_REQUEST = "PH_ALLOWANCE_UPDATE_REQUEST";
export const PH_ALLOWANCE_UPDATE_SUCCESS = "PH_ALLOWANCE_UPDATE_SUCCESS";
export const PH_ALLOWANCE_UPDATE_ERROR = "PH_ALLOWANCE_UPDATE_ERROR";

export const PH_ALLOWANCE_DELETE_REQUEST = "PH_ALLOWANCE_DELETE_REQUEST";
export const PH_ALLOWANCE_DELETE_SUCCESS = "PH_ALLOWANCE_DELETE_SUCCESS";
export const PH_ALLOWANCE_DELETE_ERROR = "PH_ALLOWANCE_DELETE_ERROR";

export const BONUS_CONFIGURATION_GET_REQUEST = "BONUS_CONFIGURATION_GET_REQUEST";
export const BONUS_CONFIGURATION_GET_SUCCESS = "BONUS_CONFIGURATION_GET_SUCCESS";
export const BONUS_CONFIGURATION_GET_ERROR = "BONUS_CONFIGURATION_GET_ERROR";

export const BONUS_CONFIGURATION_UPDATE_REQUEST = "BONUS_CONFIGURATION_UPDATE_REQUEST";
export const BONUS_CONFIGURATION_UPDATE_SUCCESS = "BONUS_CONFIGURATION_UPDATE_SUCCESS";
export const BONUS_CONFIGURATION_UPDATE_ERROR = "BONUS_CONFIGURATION_UPDATE_ERROR";

export const ADJUSTMENT_COMPONENTS_GET_REQUEST = "ADJUSTMENT_COMPONENTS_GET_REQUEST";
export const ADJUSTMENT_COMPONENTS_GET_SUCCESS = "ADJUSTMENT_COMPONENTS_GET_SUCCESS";
export const ADJUSTMENT_COMPONENTS_GET_ERROR = "ADJUSTMENT_COMPONENTS_GET_ERROR";

export const ADJUSTMENT_COMPONENTS_ADD_REQUEST = "ADJUSTMENT_COMPONENTS_ADD_REQUEST";
export const ADJUSTMENT_COMPONENTS_ADD_SUCCESS = "ADJUSTMENT_COMPONENTS_ADD_SUCCESS";
export const ADJUSTMENT_COMPONENTS_ADD_ERROR = "ADJUSTMENT_COMPONENTS_ADD_ERROR";

export const ADJUSTMENT_COMPONENTS_UPDATE_REQUEST = "ADJUSTMENT_COMPONENTS_UPDATE_REQUEST";
export const ADJUSTMENT_COMPONENTS_UPDATE_SUCCESS = "ADJUSTMENT_COMPONENTS_UPDATE_SUCCESS";
export const ADJUSTMENT_COMPONENTS_UPDATE_ERROR = "ADJUSTMENT_COMPONENTS_UPDATE_ERROR";

export const ADJUSTMENT_COMPONENTS_DELETE_REQUEST = "ADJUSTMENT_COMPONENTS_DELETE_REQUEST";
export const ADJUSTMENT_COMPONENTS_DELETE_SUCCESS = "ADJUSTMENT_COMPONENTS_DELETE_SUCCESS";
export const ADJUSTMENT_COMPONENTS_DELETE_ERROR = "ADJUSTMENT_COMPONENTS_DELETE_ERROR";

export const PAYROLL_REPORTING_EMPLOYEE_GET_REQUEST = "PAYROLL_REPORTING_EMPLOYEE_GET_REQUEST";
export const PAYROLL_REPORTING_EMPLOYEE_GET_SUCCESS = "PAYROLL_REPORTING_EMPLOYEE_GET_SUCCESS";
export const PAYROLL_REPORTING_EMPLOYEE_GET_ERROR = "PAYROLL_REPORTING_EMPLOYEE_GET_ERROR";

export const EMPLOYEE_POST_ADJUSTMENT_GET_REQUEST = "EMPLOYEE_POST_ADJUSTMENT_GET_REQUEST";
export const EMPLOYEE_POST_ADJUSTMENT_GET_SUCCESS = "EMPLOYEE_POST_ADJUSTMENT_GET_SUCCESS";
export const EMPLOYEE_POST_ADJUSTMENT_GET_ERROR = "EMPLOYEE_POST_ADJUSTMENT_GET_ERROR";

export const EMPLOYEE_POST_ADJUSTMENT_ADD_REQUEST = "EMPLOYEE_POST_ADJUSTMENT_ADD_REQUEST";
export const EMPLOYEE_POST_ADJUSTMENT_ADD_SUCCESS = "EMPLOYEE_POST_ADJUSTMENT_ADD_SUCCESS";
export const EMPLOYEE_POST_ADJUSTMENT_ADD_ERROR = "EMPLOYEE_POST_ADJUSTMENT_ADD_ERROR";

export const EMPLOYEE_POST_ADJUSTMENT_UPDATE_REQUEST = "EMPLOYEE_POST_ADJUSTMENT_UPDATE_REQUEST";
export const EMPLOYEE_POST_ADJUSTMENT_UPDATE_SUCCESS = "EMPLOYEE_POST_ADJUSTMENT_UPDATE_SUCCESS";
export const EMPLOYEE_POST_ADJUSTMENT_UPDATE_ERROR = "EMPLOYEE_POST_ADJUSTMENT_UPDATE_ERROR";

export const EMPLOYEE_POST_ADJUSTMENT_DELETE_REQUEST = "EMPLOYEE_POST_ADJUSTMENT_DELETE_REQUEST";
export const EMPLOYEE_POST_ADJUSTMENT_DELETE_SUCCESS = "EMPLOYEE_POST_ADJUSTMENT_DELETE_SUCCESS";
export const EMPLOYEE_POST_ADJUSTMENT_DELETE_ERROR = "EMPLOYEE_POST_ADJUSTMENT_DELETE_ERROR";

export const EXPENSE_TYPE_GET_REQUEST = "EXPENSE_TYPE_GET_REQUEST";
export const EXPENSE_TYPE_GET_SUCCESS = "EXPENSE_TYPE_GET_SUCCESS";
export const EXPENSE_TYPE_GET_ERROR = "EXPENSE_TYPE_GET_ERROR";
export const EXPENSE_TYPE_ADD_REQUEST = "EXPENSE_TYPE_ADD_REQUEST";
export const EXPENSE_TYPE_ADD_SUCCESS = "EXPENSE_TYPE_ADD_SUCCESS";
export const EXPENSE_TYPE_ADD_ERROR = "EXPENSE_TYPE_ADD_ERROR";
export const EXPENSE_TYPE_UPDATE_REQUEST = "EXPENSE_TYPE_UPDATE_REQUEST";
export const EXPENSE_TYPE_UPDATE_SUCCESS = "EXPENSE_TYPE_UPDATE_SUCCESS";
export const EXPENSE_TYPE_UPDATE_ERROR = "EXPENSE_TYPE_UPDATE_ERROR";
export const EXPENSE_TYPE_DELETE_REQUEST = "EXPENSE_TYPE_DELETE_REQUEST";
export const EXPENSE_TYPE_DELETE_SUCCESS = "EXPENSE_TYPE_DELETE_SUCCESS";
export const EXPENSE_TYPE_DELETE_ERROR = "EXPENSE_TYPE_DELETE_ERROR";

export const EXPENSE_SUBTYPE_GET_REQUEST = "EXPENSE_SUBTYPE_GET_REQUEST";
export const EXPENSE_SUBTYPE_GET_SUCCESS = "EXPENSE_SUBTYPE_GET_SUCCESS";
export const EXPENSE_SUBTYPE_GET_ERROR = "EXPENSE_SUBTYPE_GET_ERROR";
export const EXPENSE_SUBTYPE_ADD_REQUEST = "EXPENSE_SUBTYPE_ADD_REQUEST";
export const EXPENSE_SUBTYPE_ADD_SUCCESS = "EXPENSE_SUBTYPE_ADD_SUCCESS";
export const EXPENSE_SUBTYPE_ADD_ERROR = "EXPENSE_SUBTYPE_ADD_ERROR";
export const EXPENSE_SUBTYPE_UPDATE_REQUEST = "EXPENSE_SUBTYPE_UPDATE_REQUEST";
export const EXPENSE_SUBTYPE_UPDATE_SUCCESS = "EXPENSE_SUBTYPE_UPDATE_SUCCESS";
export const EXPENSE_SUBTYPE_UPDATE_ERROR = "EXPENSE_SUBTYPE_UPDATE_ERROR";
export const EXPENSE_SUBTYPE_DELETE_REQUEST = "EXPENSE_SUBTYPE_DELETE_REQUEST";
export const EXPENSE_SUBTYPE_DELETE_SUCCESS = "EXPENSE_SUBTYPE_DELETE_SUCCESS";
export const EXPENSE_SUBTYPE_DELETE_ERROR = "EXPENSE_SUBTYPE_DELETE_ERROR";

export const EMPLOYEE_EXPENSE_GET_REQUEST = "EMPLOYEE_EXPENSE_GET_REQUEST";
export const EMPLOYEE_EXPENSE_GET_SUCCESS = "EMPLOYEE_EXPENSE_GET_SUCCESS";
export const EMPLOYEE_EXPENSE_GET_ERROR = "EMPLOYEE_EXPENSE_GET_ERROR";

export const EMPLOYEE_EXPENSE_ADD_REQUEST = "EMPLOYEE_EXPENSE_ADD_REQUEST";
export const EMPLOYEE_EXPENSE_ADD_SUCCESS = "EMPLOYEE_EXPENSE_ADD_SUCCESS";
export const EMPLOYEE_EXPENSE_ADD_ERROR = "EMPLOYEE_EXPENSE_ADD_ERROR";

export const EMPLOYEE_EXPENSE_UPDATE_REQUEST = "EMPLOYEE_EXPENSE_UPDATE_REQUEST";
export const EMPLOYEE_EXPENSE_UPDATE_SUCCESS = "EMPLOYEE_EXPENSE_UPDATE_SUCCESS";
export const EMPLOYEE_EXPENSE_UPDATE_ERROR = "EMPLOYEE_EXPENSE_UPDATE_ERROR";

export const EMPLOYEE_EXPENSE_DELETE_REQUEST = "EMPLOYEE_EXPENSE_DELETE_REQUEST";
export const EMPLOYEE_EXPENSE_DELETE_SUCCESS = "EMPLOYEE_EXPENSE_DELETE_SUCCESS";
export const EMPLOYEE_EXPENSE_DELETE_ERROR = "EMPLOYEE_EXPENSE_DELETE_ERROR";

export const APPROVER_EXPENSE_GET_REQUEST = "APPROVER_EXPENSE_GET_REQUEST";
export const APPROVER_EXPENSE_GET_SUCCESS = "APPROVER_EXPENSE_GET_SUCCESS";
export const APPROVER_EXPENSE_GET_ERROR = "APPROVER_EXPENSE_GET_ERROR";
export const APPROVER_EXPENSE_UPDATE_REQUEST = "APPROVER_EXPENSE_UPDATE_REQUEST";
export const APPROVER_EXPENSE_UPDATE_SUCCESS = "APPROVER_EXPENSE_UPDATE_SUCCESS";
export const APPROVER_EXPENSE_UPDATE_ERROR = "APPROVER_EXPENSE_UPDATE_ERROR";

export const EMPLOYEE_EXPENSE_CSV_GET_REQUEST = "EMPLOYEE_EXPENSE_CSV_GET_REQUEST";
export const EMPLOYEE_EXPENSE_CSV_GET_SUCCESS = "EMPLOYEE_EXPENSE_CSV_GET_SUCCESS";
export const EMPLOYEE_EXPENSE_CSV_GET_ERROR = "EMPLOYEE_EXPENSE_CSV_GET_ERROR";

export const REGISTRATION_NUMBER_GET_REQUEST = "REGISTRATION_NUMBER_GET_REQUEST";
export const REGISTRATION_NUMBER_GET_SUCCESS = "REGISTRATION_NUMBER_GET_SUCCESS";
export const REGISTRATION_NUMBER_GET_ERROR = "REGISTRATION_NUMBER_GET_ERROR";

export const REGISTRATION_NUMBER_ADD_REQUEST = "REGISTRATION_NUMBER_ADD_REQUEST";
export const REGISTRATION_NUMBER_ADD_SUCCESS = "REGISTRATION_NUMBER_ADD_SUCCESS";
export const REGISTRATION_NUMBER_ADD_ERROR = "REGISTRATION_NUMBER_ADD_ERROR";

export const ECMS_COMPONENTS_GET_REQUEST = "ECMS_COMPONENTS_GET_REQUEST";
export const ECMS_COMPONENTS_GET_SUCCESS = "ECMS_COMPONENTS_GET_SUCCESS";
export const ECMS_COMPONENTS_GET_ERROR = "ECMS_COMPONENTS_GET_ERROR";

export const ECMS_COMPONENTS_ADD_REQUEST = "ECMS_COMPONENTS_ADD_REQUEST";
export const ECMS_COMPONENTS_ADD_SUCCESS = "ECMS_COMPONENTS_ADD_SUCCESS";
export const ECMS_COMPONENTS_ADD_ERROR = "ECMS_COMPONENTS_ADD_ERROR";

export const ECMS_COMPONENTS_UPDATE_REQUEST = "ECMS_COMPONENTS_UPDATE_REQUEST";
export const ECMS_COMPONENTS_UPDATE_SUCCESS = "ECMS_COMPONENTS_UPDATE_SUCCESS";
export const ECMS_COMPONENTS_UPDATE_ERROR = "ECMS_COMPONENTS_UPDATE_ERROR";

export const ECMS_COMPONENTS_DELETE_REQUEST = "ECMS_COMPONENTS_DELETE_REQUEST";
export const ECMS_COMPONENTS_DELETE_SUCCESS = "ECMS_COMPONENTS_DELETE_SUCCESS";
export const ECMS_COMPONENTS_DELETE_ERROR = "ECMS_COMPONENTS_DELETE_ERROR";

// --- Employee ECMS Adjustment ---
export const EMPLOYEE_ECMS_ADJUSTMENT_GET = "EMPLOYEE_ECMS_ADJUSTMENT_GET";
export const EMPLOYEE_ECMS_ADJUSTMENT_GET_SUCCESS = "EMPLOYEE_ECMS_ADJUSTMENT_GET_SUCCESS";
export const EMPLOYEE_ECMS_ADJUSTMENT_GET_ERROR = "EMPLOYEE_ECMS_ADJUSTMENT_GET_ERROR";

export const EMPLOYEE_ECMS_ADJUSTMENT_ADD = "EMPLOYEE_ECMS_ADJUSTMENT_ADD";
export const EMPLOYEE_ECMS_ADJUSTMENT_ADD_SUCCESS = "EMPLOYEE_ECMS_ADJUSTMENT_ADD_SUCCESS";
export const EMPLOYEE_ECMS_ADJUSTMENT_ADD_ERROR = "EMPLOYEE_ECMS_ADJUSTMENT_ADD_ERROR";

export const EMPLOYEE_ECMS_ADJUSTMENT_UPDATE = "EMPLOYEE_ECMS_ADJUSTMENT_UPDATE";
export const EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_SUCCESS = "EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_SUCCESS";
export const EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_ERROR = "EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_ERROR";

export const EMPLOYEE_ECMS_ADJUSTMENT_DELETE = "EMPLOYEE_ECMS_ADJUSTMENT_DELETE";
export const EMPLOYEE_ECMS_ADJUSTMENT_DELETE_SUCCESS = "EMPLOYEE_ECMS_ADJUSTMENT_DELETE_SUCCESS";
export const EMPLOYEE_ECMS_ADJUSTMENT_DELETE_ERROR = "EMPLOYEE_ECMS_ADJUSTMENT_DELETE_ERROR";
